import { FilterColumnItem } from "@vviinn/user-managment-client-ts";
import { CampaignFilterSortingEnum } from "@vviinn/user-managment-client-ts/dist/models/Campaign";

import { sortFilters } from "./sortFilters";
import { availableInterfaceFilters } from "../../../../../helpers/availableInterfaceFilters";

const initActiveSingleFilter = (
  enabledFilterColumns: FilterColumnItem[],
  filterKey: string,
) => enabledFilterColumns.find(({ column }) => column === filterKey);
const initActiveGroupFilter = (
  enabledFilterColumns: FilterColumnItem[],
  columnsGroup: string[],
) =>
  enabledFilterColumns.find(
    ({ column }) => !!columnsGroup.find((item) => item === column),
  );

const removeIrrelevantFilters = (
  availableFilters: string[],
  enabledFilters: FilterColumnItem[],
) => enabledFilters.filter(({ column }) => availableFilters.includes(column));

export const initFilterConfig = (
  availableCampaignFilters: string[],
  enabledFilterColumns: FilterColumnItem[],
  initFiltersSorting?: CampaignFilterSortingEnum,
) => {
  const activeFiltersAmount = removeIrrelevantFilters(
    availableCampaignFilters,
    enabledFilterColumns,
  ).length;

  const enabledColumns = enabledFilterColumns.map(({ column }) => column);

  const { booleanInterfaceControls, valuedInterfaceControls } =
    availableInterfaceFilters(availableCampaignFilters);

  const defaultFiltersRenderOrder = [
    ...valuedInterfaceControls.map((item) => ({
      columnsGroup: item.columnsGroup,
      columnGroupLabel: item.columnGroupLabel,
      targetFilter: item.columnGroupLabel,
      activeFilter: initActiveGroupFilter(
        enabledFilterColumns,
        item.columnsGroup,
      ),
    })),
    ...booleanInterfaceControls.map((filter) => ({
      columnsGroup: undefined,
      columnGroupLabel: undefined,
      targetFilter: filter,
      activeFilter: initActiveSingleFilter(enabledFilterColumns, filter),
    })),
  ];

  const defaultFiltersColumnsOrder = [
    ...valuedInterfaceControls.map((item) => item.columnsGroup).flat(),
    ...booleanInterfaceControls,
  ];

  const initInterfaceControls = sortFilters(
    defaultFiltersRenderOrder,
    initFiltersSorting === "manual" ? enabledColumns : undefined,
  );

  return {
    activeFiltersAmount,
    enabledColumns,
    defaultFiltersColumnsOrder,
    initInterfaceControls,
  };
};
